import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-tab-group-reporting',
  templateUrl: './tab-group-dashboard.component.html',
  styleUrls: ['./tab-group-dashboard.component.scss']
})
export class TabGroupDashboardComponent extends BaseGeneralComponent implements OnInit {
  selectedIndex: any;
  sectionId: string;

  constructor(private _Activatedroute: ActivatedRoute,
              private userService: UsersService) {
    super();
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }

  ngOnInit() {
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
  }

}
